var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 50C32.1304 50 38.4893 47.3661 43.1777 42.6777C47.8661 37.9893 50.5 31.6304 50.5 25C50.5 18.3696 47.8661 12.0107 43.1777 7.32233C38.4893 2.63392 32.1304 0 25.5 0C18.8696 0 12.5107 2.63392 7.82233 7.32233C3.13392 12.0107 0.5 18.3696 0.5 25C0.5 31.6304 3.13392 37.9893 7.82233 42.6777C12.5107 47.3661 18.8696 50 25.5 50ZM33.7422 20.7715L25.9297 33.2715C25.5195 33.9258 24.8164 34.3359 24.0449 34.375C23.2734 34.4141 22.5312 34.0625 22.0723 33.4375L17.3848 27.1875C16.6035 26.1523 16.8184 24.6875 17.8535 23.9062C18.8887 23.125 20.3535 23.3398 21.1348 24.375L23.7715 27.8906L29.7676 18.291C30.4512 17.1973 31.8965 16.8555 33 17.5488C34.1035 18.2422 34.4355 19.6777 33.7422 20.7812V20.7715Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3f5a9a0957e819fee2d4458a8499ae81.svg";
export { ForwardRef as ReactComponent };